import { browser } from "$app/environment";

type Theme = "modern" | "brutal";

class ThemeState {
  current = $state<Theme>("modern");

  toggle() {
    this.current = this.current === "modern" ? "brutal" : "modern";
    this.apply();
  }

  set(t: Theme) {
    this.current = t;
    this.apply();
  }

  private apply() {
    if (!browser) return;
    document.body.classList.toggle("brutal", this.current === "brutal");
  }
}

export const theme = new ThemeState();
